import { ILink } from 'src/views/Links/types';
import { measureTextWidth } from './measureTextWidth';

let previousParameterNames: string[] = [];

export function getParameterNames(
  links: ILink[],
  parameterOrder: Array<{
    name: string;
    order: number;
  }>,
  profileParameterName: string
) {
  const orders = [{ name: profileParameterName, order: 0 }, ...parameterOrder];
  const parameterNameSet = new Set<string>();
  const parameterLengths: { [key: string]: number } = {};

  links.forEach((link) => {
    link.parameters.forEach((parameter) => {
      parameterNameSet.add(parameter.name);
      parameterLengths[parameter.name] = Math.max(
        parameterLengths[parameter.name] || 0,
        measureTextWidth(parameter.name),
        measureTextWidth(parameter.value)
      );
    });
  });
  const newParameterNameSet = new Set<string>();
  previousParameterNames.forEach((name) => {
    if (parameterNameSet.has(name)) {
      newParameterNameSet.add(name);
    }
  });
  parameterNameSet.forEach((name) => newParameterNameSet.add(name));
  const parameterNames = Array.from(newParameterNameSet);
  previousParameterNames = parameterNames;
  return parameterNames
    .map((name) => {
      const order = orders.find((p) => p.name === name);
      return {
        name,
        order: order ? order.order : 9999,
      };
    })
    .sort((a, b) => (a.order < b.order ? -1 : 1))
    .map(({ name }) => ({
      name,
      length: parameterLengths[name],
    }));
}



// WEBPACK FOOTER //
// ./src/services/links/getParameterNames.ts